import Swal from 'sweetalert2';
import axios from '../../../services/axios';
import { decode as base64_decode, encode as base64_encode } from 'base-64';
import { ENDERECO_API } from '../../../config/constant';
import { statusMap } from '../Arrays';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import toast from 'react-hot-toast';
import moment from 'moment';

/* Formata CNPJ/CPF com traços e pontos. Suporta CNPJ alfanumérico (novo formato). */
export const FormatCnpjCpf = (value) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  // Remove tudo que não é letra ou dígito e normaliza para maiúsculo
  const clean = String(value).replace(/[^A-Z0-9]/gi, '').toUpperCase();

  if (clean.length === 0) {
    return '';
  }

  // CPF: 11 dígitos (sempre numérico)
  if (clean.length === 11) {
    return clean.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
  }

  // CNPJ: 14 caracteres (pode ser alfanumérico no novo formato)
  if (clean.length === 14) {
    return clean.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, '$1.$2.$3/$4-$5');
  }

  return String(value);
};


export /**
 * Verifica a permissao do usuario
 *
 * @param {*} dataRestricoes
 * @param {*} restricao
 * @return {*}
 */
  const VerificaPermissaoUsuario = (dataRestricoes, restricao, moduloAtual = 0) => {
    // const configContext = useContext(ConfigContext);
    // const modulo = configContext.state.moduloAtual;

    if (moduloAtual === 1) {
      return false;
    }

    if (Array.isArray(dataRestricoes) && dataRestricoes.length > 0) {
      let boolRestricao = false;
      dataRestricoes.forEach((item) => {
        if (item.item === restricao) {
          boolRestricao = true;
        }
      });

      if (boolRestricao === true) {
        Swal.fire({
          title: 'Acesso Negado',
          text: 'Você não possui permissão para acessar essa funcionalidade.',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#4099ff',
        });
      }
      return boolRestricao;
    } else {
      return false;
    }
  };

export const SalvaDataPeriodoPadrao = (salvarData, data) => {
  const sessiosS = JSON.parse(base64_decode(sessionStorage.getItem(`ddesp`)));
  const localStorage_ = localStorage.getItem(`ddespU${base64_encode(sessiosS[3])}`);
  const localDescrip = JSON.parse(base64_decode(localStorage_));
  const usr = localDescrip[1];
  if (salvarData) {
    const periodo_ = data;
    localStorage.setItem(`periodoDoc${usr}`, JSON.stringify(periodo_));
  } else {
    localStorage.removeItem(`periodoDoc${usr}`);
  }
};

export const TrataDataIniEmpresas = (dados, modulo) => {
  // const configContext = useContext(ConfigContext);
  let empresaSelecionadaStorage = localStorage.getItem('empDoc');
  let empselecionada = [];
  let filterModulo = [];

  //filtra as empresas de acordo com o modulo
  filterModulo = dados.filter((obj) => {
    if (Number(modulo) === 0 || modulo === undefined) {
      return obj.cad_gestao === 't';
    } else {
      return obj.cad_resgate_xml === 't';
    }
  });


  // Pertinente ao localStorage
  if (empresaSelecionadaStorage !== undefined && empresaSelecionadaStorage !== null) {
    empresaSelecionadaStorage = JSON.parse(base64_decode(empresaSelecionadaStorage));
    empselecionada = filterModulo[0];

    const filtered = filterModulo.filter((obj) => {
      try {
        return obj.value === empresaSelecionadaStorage[0].value;
      } catch (error) {

        return obj.value === empresaSelecionadaStorage.value;
      }
    });

    if (filtered.length > 0) {

      empselecionada = filtered[0];
    } else {

    }
  } else {
    empselecionada = filterModulo[0];
  }

  return [empselecionada, filterModulo];
};

export const CheckDataUser = async () => {
  return new Promise(function (resolve, reject) {
    axios.get('/api/account/', { dest: 'checkData' }).then((res) => {
      const usersRt = sessionStorage.getItem(`ddesp`) !== null ? JSON.parse(base64_decode(sessionStorage.getItem(`ddesp`))) : null;
      const response = res.data;
      // const possuiEmpresas = response.possuiEmpresas; //ficticio = dados Fic. | real = dados reais | false = sem dados
      // const possuiCert = response.possuiCert; //cert = possui certificado | no_cert  = não possui certificado
      // const possuiNotas = response.possuiNotas; //true = possui notas | false = não possui notas
      // const primeiroAcesso = response.primeiroAcesso; //true = primeiro acesso | false = não é primeiro acesso

      usersRt[11][0] = res.data;
      sessionStorage.setItem('ddesp', base64_encode(JSON.stringify(usersRt)));

      resolve(res.data);
    });
  });
};

export const CheckSessaoUser = async (fetchUserData = false) => {
  try {
    const sessionRaw = sessionStorage.getItem('ddesp');
    if (!sessionRaw) return null;

    const res = await axios.get('/api/account/', { dest: 'checkSessao', fetchUser: fetchUserData });
    const resultado = res.data;
    if (!resultado) return null;

    // Sessão duplicada (token inválido)
    if (resultado.tokenValido === false) {
      let timerInterval;
      await Swal.fire({
        title: 'Sessão Duplicada!',
        html: 'Foi iniciada uma nova sessão com seu usuário.<br/>Esta sessão será encerrada!<br/><b></b>',
        icon: 'warning',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        timerProgressBar: true,
        timer: 5000,
        didOpen: () => {
          Swal.showLoading();
          const timer = Swal.getPopup().querySelector('b');
          timerInterval = setInterval(() => {
            timer.textContent = (Swal.getTimerLeft() / 1000).toFixed(0);
          }, 100);
        },
        willClose: () => clearInterval(timerInterval),
      });
      sessionStorage.clear();
      window.location.href = '/login';
      return null;
    }

    // Idle timeout expirado — countdown de 10s para o user se manifestar
    if (resultado.idleExpirado === true) {
      let timerInterval;
      const result = await Swal.fire({
        title: 'Sessão prestes a expirar',
        html: 'Você ficou inativo. A sessão será encerrada em <b>10</b> segundos.',
        icon: 'warning',
        showConfirmButton: true,
        confirmButtonText: 'Continuar conectado',
        confirmButtonColor: '#4099ff',
        allowOutsideClick: false,
        allowEscapeKey: false,
        timerProgressBar: true,
        timer: 10000,
        didOpen: () => {
          const b = Swal.getPopup().querySelector('b');
          timerInterval = setInterval(() => {
            b.textContent = (Swal.getTimerLeft() / 1000).toFixed(0);
          }, 100);
        },
        willClose: () => clearInterval(timerInterval),
      });
      if (result.isConfirmed) {
        // Atualiza o log de idle para 'idle_renovado'
        const idleLogId = resultado.idleLogId ?? null;
        if (idleLogId) {
          await axios.post('/api/users/', { dest: 'renovarSessaoIdle', dataPost: idleLogId });
        }
        return null;
      }
      // Timer zerou ou dismiss → encerra sessão (log permanece como 'idle')
      sessionStorage.clear();
      localStorage.removeItem('serviceToken');
      window.location.replace('/');
      return null;
    }

    // IP ou horário bloqueado
    if (resultado.seguranca && !resultado.seguranca.permitido) {
      let html = 'Acesso bloqueado por restrições de segurança.';
      if (resultado.seguranca.validacoes?.ip?.permitido === false) {
        html = 'Seu IP não está autorizado para acessar esta conta.<br/><br/>Entre em contato com o administrador da empresa.';
      } else if (resultado.seguranca.validacoes?.horario?.permitido === false) {
        html = 'O acesso a esta conta está fora do horário permitido.<br/><br/>Entre em contato com o administrador da empresa.';
      }
      await Swal.fire({
        title: 'Acesso bloqueado',
        html,
        icon: 'warning',
        confirmButtonText: 'OK',
        confirmButtonColor: '#4099ff',
        allowOutsideClick: false,
      });
      sessionStorage.clear();
      localStorage.removeItem('serviceToken');
      window.location.replace('/');
      return null;
    }

    // Atualiza dados do user no sessionStorage (apenas quando fetchUserData=true e resultado retornou user)
    if (resultado.user) {
      const usersRt = sessionStorage.getItem('ddesp') !== null
        ? JSON.parse(base64_decode(sessionStorage.getItem('ddesp')))
        : null;
      if (usersRt) {
        usersRt[11][0] = resultado.user;
        sessionStorage.setItem('ddesp', base64_encode(JSON.stringify(usersRt)));
      }
    }

    // MFA pendente: dispara evento para o AuthGuard resetar o gate
    if (resultado.mfaPending === true) {
      window.dispatchEvent(new CustomEvent('mfa-pending'));
    }

    return resultado;
  } catch {
    return null;
  }
};

//Função para baixar arquivo zip do instalador Cloud Monitor
export const DownloadCloudMonitor = () => {
  //Acessar pasta cloud_monitor e baixar o arquivo zip
  window.open(`${ENDERECO_API}download/CloudMonitor_Instalador.zip`, '_blank');
};

//Função que recarrega o sessionStorage
export const ReloadSessionStorage = async () => {
  try {
    const sessionRaw = sessionStorage.getItem('ddesp');
    if (!sessionRaw) throw new Error('Sessão não encontrada.');
    const sessionDecoded = JSON.parse(base64_decode(sessionRaw));
    const empresaId = sessionDecoded[0];
    const usuarioId = sessionDecoded[3];
    const usuarioEmail = sessionDecoded[6];
    const varias = sessionDecoded[18];

    if (!empresaId || !usuarioId || !usuarioEmail) {
      throw new Error('Dados de sessão inválidos.');
    }

    Swal.fire({
      title: 'Atualizando...',
      text: 'Aguarde enquanto seus dados estão sendo atualizados.',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading()
    });

    const dataPost = [empresaId, usuarioId, usuarioEmail, varias];
    const response = await axios.post('/api/account/', {
      dest: 'atualizarDados',
      dataPost
    });

    if (response.status === 200) {
      const updatedSession = response.data;
      sessionStorage.setItem('ddesp', base64_encode(JSON.stringify(updatedSession)));
      Swal.fire({
        icon: 'success',
        title: 'Atualização concluída!',
        text: 'Seus dados foram atualizados com sucesso.',
        timer: 2000,
        showConfirmButton: false
      });

      // Encaminhar para a dashboard
      window.location.href = '/dashboard';
    } else {
      throw new Error('Resposta inválida ou sessão não atualizada.');
    }

  } catch (error) {
    console.error('Erro ao recarregar sessão:', error);
    Swal.fire({
      icon: 'error',
      title: 'Erro ao atualizar!',
      text: error.message || 'Ocorreu um problema ao atualizar seus dados. Tente novamente.',
      confirmButtonText: 'OK'
    });
  }
};

export const CalcularDataExpiracao = (data, diasAdicionais) => {
  const dataAtivacao = data;
  const dataExpiracao = data.clone().add(diasAdicionais, 'days').endOf('day'); // Adiciona os dias adicionais e define o final do dia
  const dataAtual = moment();
  const expirado = dataAtual.isAfter(dataExpiracao); // Verifica se a data atual é maior que a data de expiração
  const diasRestantes = dataExpiracao.diff(dataAtual, 'days'); // Calcula a diferença em dias
  const diasRestantesFormatado = diasRestantes < 0 ? 0 : diasRestantes; // Se a diferença for negativa, define como 0
  return { diasRestantes: diasRestantesFormatado, expirado };

}

//Função para remover acentos e caracteres especiais

export const RemoverAcentosECaracteresEspeciais = (valor) => {
  return valor
    .normalize('NFD') // Normaliza o valor em forma de decomposição (NFD)
    .replace(/[\u0300-\u036f]/g, '') // Remove acentos
    .replace(/[^a-zA-Z0-9\s]/g, ''); // Permite letras, números e espaços
};

export const DownloadXlsxTabela = (dadosTabela, colunas, visibilidade, documento, origem) => {

  // Função utilitária para converter 'dd/mm/yyyy' em objeto Date
  const parseData = (dataStr) => {
    const [dia, mes, ano] = dataStr.split('/');
    return new Date(`${ano}-${mes}-${dia}`);
  };
  const XLSX = require('xlsx');
  const gerarXlsxTabela = (dadosTabela, colunas, visibilidade, documento, origem) => {
    let montarObjetosColunas = [];
    colunas.forEach((ordem) => {
      if (visibilidade[ordem] === true) {
        if (ordem !== 'marcador' && ordem !== 'Opções') {
          if (ordem === 'observacao') {
            montarObjetosColunas.push({ anotacoes: '' });
          } else {
            montarObjetosColunas.push({ [ordem]: '' });
          }
        }
      }
    });

    //

    const xlsxDados = dadosTabela.map((item) => {
      let novaColuna = {};
      montarObjetosColunas.forEach((coluna) => {
        //
        let chave = Object.keys(coluna)[0];
        if (chave === undefined) {
          chave = '';
        }
        if (documento === 'nfe') {
          novaColuna[chave] = item[chave] !== undefined ? item[chave] : '';
          if (chave === 'anotacoes') {
            novaColuna[chave] = item['observacao'] !== undefined ? item['observacao'] : '';
          }
        }
        if (documento === 'cte') {
          novaColuna[chave] = item[chave] !== undefined ? item[chave] : '';
          if (chave === 'anotacoes') {
            novaColuna[chave] = item['observacao'] !== undefined ? item['observacao'] : '';
          }
        }
        if (documento === 'nfse') {
          if (origem === 1) {
            // NFS-e Nacional
            switch (chave) {
              case 'prestador':
                item.prestador_nome && item.prestador_cnpj_cpf ? (novaColuna[chave] = `${item.prestador_nome} - ${item.prestador_cnpj_cpf}`) : (novaColuna[chave] = 'N/A');
                break;
              case 'tomador':
                item.tomador_nome && item.tomador_cnpj_cpf ? (novaColuna[chave] = `${item.tomador_nome} - ${item.tomador_cnpj_cpf}`) : (novaColuna[chave] = 'N/A');
                break;
              case 'intermediario':
                item.interm_nome && item.interm_cnpj_cpf ? (novaColuna[chave] = `${item.interm_nome} - ${item.interm_cnpj_cpf}`) : (novaColuna[chave] = 'N/A');
                break;
              case 'iss_retido':
                novaColuna[chave] = item[chave] === 'f' ? 'Não' : 'Sim';
                break;
              case 'status':
                novaColuna[chave] = item[chave] === 'f' ? 'Autorizada' : 'Cancelada';
                break;
              case 'informacoes':
                novaColuna[chave] = item[chave] !== null ? item[chave] : 'N/A';
                break;
              case 'tipo':
                if (item[chave] === '0') {
                  novaColuna[chave] = 'Prestador';
                } else if (item[chave] === '1') {
                  novaColuna[chave] = 'Tomador';
                } else {
                  novaColuna[chave] = 'Intermediário';
                }
                break;
              case 'cstat':
                novaColuna[chave] = statusMap[item[chave]] ? statusMap[item[chave]].situacao : statusMap['default'].situacao;
                break;
              default:
                novaColuna[chave] = item[chave] !== undefined ? item[chave] : '';
                break;
            }
          } else if (origem === 0) {
            switch (chave) {
              case 'prestador':
                item.prestador_nome && item.prestador_cnpj ? (novaColuna[chave] = `${item.prestador_nome} - ${item.prestador_cnpj}`) : (novaColuna[chave] = 'N/A');
                break;
              case 'tomador':
                item.tomador_nome && item.tomador_cnpj ? (novaColuna[chave] = `${item.tomador_nome} - ${item.tomador_cnpj}`) : (novaColuna[chave] = 'N/A');
                break;
              default:
                novaColuna[chave] = item[chave] !== undefined ? item[chave] : '';
                break;
            }
          } else if (origem === 2) { // Ambos os tipos
            switch (chave) {
              case 'origem':
                novaColuna[chave] = item[chave] === '0' ? 'Municipal' : item[chave] === '1' ? 'Nacional' : 'Todas';
                break;
              case 'prestador':
                item.prestador_nome && item.prestador_cnpj ? (novaColuna[chave] = `${item.prestador_nome} - ${item.prestador_cnpj}`) : (novaColuna[chave] = 'N/A');
                break;
              case 'tomador':
                item.tomador_nome && item.tomador_cnpj ? (novaColuna[chave] = `${item.tomador_nome} - ${item.tomador_cnpj}`) : (novaColuna[chave] = 'N/A');
                break;
                // case 'emissao':
                //   // Formata a data de emissão
                //   novaColuna[chave] = item[chave] ? moment(item[chave]).format('DD/MM/YYYY') : 'N/A';
                //   

                //   break;
              default:
                novaColuna[chave] = item[chave] !== undefined ? item[chave] : '';
                break;
            }
          }
        }
        if (documento === 'nfce') {
          novaColuna[chave] = item[chave] !== undefined ? item[chave] : '';
          if (chave === 'anotacoes') {
            novaColuna[chave] = item['observacao'] !== undefined ? item['observacao'] : '';
          }
        }
        if (documento === 'resgate') {
          novaColuna[chave] = item[chave] !== undefined ? item[chave] : '';
        }
      });

      return novaColuna;

    }).sort((a, b) => {
      const dataA = parseData(a.emissao || a.data_cadastro || a.data);
      const dataB = parseData(b.emissao || b.data_cadastro || b.data);
      return dataB - dataA;
    });


    return xlsxDados;
  };
  const xlsDados = gerarXlsxTabela(dadosTabela, colunas, visibilidade, documento, origem);
  if (xlsDados.length === 0) {
    Swal.fire({
      title: 'Atenção',
      text: 'Não há dados para exportar.',
      icon: 'warning',
      confirmButtonText: 'OK',
      confirmButtonColor: '#4099ff',
    });
    return;
  }
  const ws = XLSX.utils.json_to_sheet(xlsDados);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, `historico_${documento}`);
  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([wbout], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const hoje = new Date();
  const dia = hoje.getDate().toString().padStart(2, '0');
  const mes = (hoje.getMonth() + 1).toString().padStart(2, '0');
  const ano = hoje.getFullYear();
  const nomeArquivo = `historico_${documento}_${dia}${mes}${ano}.xlsx`;

  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, nomeArquivo);
  } else {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = nomeArquivo;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
  }
};

export const DownloadPdfTabela = (dadosTabela, colunas, visibilidade, documento, origem) => {

  const gerarPdfTabela = (dadosTabela, colunas, visibilidade, documento, origem) => {
    let montarObjetosColunas = [];
    colunas.forEach((ordem) => {
      if (visibilidade[ordem] === true) {
        if (ordem !== 'marcador' && ordem !== 'Opções') {
          montarObjetosColunas.push({ [ordem]: '' });
        }
      }
    });

    const pdfDados = dadosTabela.map((item) => {
      let novaColuna = {};
      montarObjetosColunas.forEach((coluna) => {
        let chave = Object.keys(coluna)[0];
        if (chave === undefined) {
          chave = '';
        }
        if (chave === 'anotacoes') {
          novaColuna[chave] = item['observacao'] !== undefined ? item['observacao'] : '';
        }
        novaColuna[chave] = item[chave] !== undefined ? item[chave] : '';
        return novaColuna;
      });
      return novaColuna;
    }).sort((a, b) => b.emissao - a.emissao);
    return { pdfDados, montarObjetosColunas };
  };
  const { pdfDados, montarObjetosColunas } = gerarPdfTabela(dadosTabela, colunas, visibilidade, documento, origem);
  if (pdfDados.length === 0) {
    Swal.fire({
      title: 'Atenção',
      text: 'Não há dados para exportar.',
      icon: 'warning',
      confirmButtonText: 'OK',
      confirmButtonColor: '#4099ff',
    });
    return;
  }
  const doc = new jsPDF();
  const hoje = new Date();
  const dia = hoje.getDate().toString().padStart(2, '0');
  const mes = (hoje.getMonth() + 1).toString().padStart(2, '0');
  const ano = hoje.getFullYear();
  const nomeArquivo = `historico_${documento}_${dia}${mes}${ano}.pdf`;

  const columns = montarObjetosColunas.map((col) => Object.keys(col)[0]);

  if (columns.length > 5) {
    Swal.fire({
      title: 'Ops',
      icon: 'info',
      showCancelButton: false,
      html: 'A quantidade de colunas excede o limite para exportação em PDF.',
      confirmButtonText: 'OK',
      confirmButtonColor: '#007bff',
      //reverseButtons: true
    });
    return;
  }

  const columnStyles = columns.reduce((acc, col, index) => {
    acc[index] = { cellWidth: 30 };
    if (col === 'chave_acesso' || col === 'chave_nfse') {
      acc[index] = { cellWidth: 80 };
    }
    return acc;
  }, {});

  doc.autoTable({
    head: [columns],
    body: pdfDados.map((row) => columns.map((col) => row[col])),
    styles: { theme: 'striped', fontSize: 8 },
    columnStyles: columnStyles,
  });

  doc.save(nomeArquivo);
};

export const CopiarLinhasTabela = (dadosTabela, useRefTable, documento) => {
  const selecionadas = useRefTable.current?.getSelectedRowModel();
  const temSelecionadas = selecionadas?.rows?.length > 0;
  let chave = 'chave_acesso';
  switch (documento) {
    case 'nfe':
    case 'cte':
    case 'nfce':
    case 'sat':
      chave = 'chave_acesso';
      break;
    case 'nfse':
      chave = 'chave_nfse';
      break;
    default:
      chave = 'chave_acesso';
      break;
  }
  let chavesCopiadas = [];
  if (!temSelecionadas) {
    chavesCopiadas = dadosTabela.map((item) => item[chave]);
  } else {
    chavesCopiadas = selecionadas.rows.map((item) => item.original[chave]);
  }
  const textoCopiado = chavesCopiadas.join('\n');
  const textarea = document.createElement('textarea');
  textarea.value = textoCopiado;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
  navigator.clipboard.writeText(textoCopiado);
  toast.success('Chaves de acesso copiadas para a área de transferência!');
};

export const ObterCaminhoDaUrl = (url) => {
  // Remove o prefixo do endereço da API e o sufixo da URL
  let caminho = url.split('#')[0].split('!')[0];
  if (!caminho.startsWith('/')) {
    caminho = '/' + caminho;
  }
  return caminho;
};

export const insertGTM = () => {
  const GTM_ID = 'GTM-WHV6NR6';
  if (document.getElementById('gtmScript')) return;

  const script = document.createElement('script');
  script.id = 'gtmScript';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);

  const noScript = document.createElement('noscript');
  noScript.id = 'gtmNoScript';
  noScript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.body.insertBefore(noScript, document.body.firstChild);
};

export const removeGTM = () => {
  const script = document.getElementById('gtmScript');
  const noScript = document.getElementById('gtmNoScript');
  if (script) script.remove();
  if (noScript) noScript.remove();
};

export const FormataData = (data) => {
  if (!data) return '';
  const dataFormatada = moment(data, 'YYYY-MM-DD').format('DD/MM/YYYY');
  return dataFormatada;
}
